<template>
  <div class="mt-5">
    <v-layout>
      <v-flex>
        <v-btn flat @click="onBack">
          <i class="fas fa-chevron-left mr-1"></i>
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="grey" @click="onSave" v-if="!isSaveOnly">
          <i class="fas fa-save mr-1"></i>
          {{ $t('save_draft') }}
        </v-btn>
        <v-btn depressed color="primary" @click="onSend">
          <i class="fas fa-paper-plane mr-1"></i>
          {{ $t(isSaveOnly ? 'save_and_send' : 'Send') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container>
      <h2>
        {{ $t('Broadcast Detail') }}
        <a href="https://blog.zwiz.app/5typesfbbroadcast/" target="blank"
          ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
        ></a>
      </h2>
    </v-container>
    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('broadcastName') }">
          <input
            type="text"
            class="form-control"
            name="broadcastName"
            data-vv-name="broadcastName"
            :data-vv-as="$t('Broadcast Name')"
            :placeholder="$t('Broadcast Name')"
            v-validate="'required'"
            v-model="name"
          />
          <span class="text-error" v-show="errors.has('broadcastName')">{{
            errors.first('broadcastName')
          }}</span>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>
          {{ $t('Target') }}
          <a href="https://tinyurl.com/dd8x8tzc" target="blank"
            ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
          ></a>
        </div>

        <template v-if="loadingEstimate">
          <div class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </template>
        <template v-else>
          <p
            class="primary-color"
            v-if="
              !(
                (groupType.value == 'line' || groupType.value == 'line-group') &&
                isLineBroadcastAll == true
              )
            "
          >
            {{ $t('approximately') }}
            <template v-if="sendtype === 'NTN_BROADCAST'">
              <template v-if="value === false">
                N/A
              </template>
              <tween-num
                v-else
                :value="
                  tntType.value == 'DAILY'
                    ? parseInt(count_optin_daily)
                    : tntType.value == 'WEEKLY'
                    ? parseInt(count_optin_weekly)
                    : tntType.value == 'MONTHLY'
                    ? parseInt(count_optin_monthly)
                    : false
                "
                :initial="0"
                :formatter="numberFormat"
                key="promotion"
              ></tween-num>
              <span>&nbsp;{{ $t('users') }}</span>
            </template>
            <template v-else>
              <template
                v-if="
                  !['line', 'line-group', 'google'].includes(groupType.value) &&
                    sendtype == 'promotion'
                "
              >
                <template v-if="value === false">
                  N/A
                </template>
                <tween-num
                  v-else
                  :value="parseInt(estimate_user)"
                  :initial="0"
                  :formatter="numberFormat"
                  key="promotion"
                ></tween-num>
                <span
                  >&nbsp;{{ $t('users') }}&nbsp;({{
                    $t(`Number of users who talked with chatbot within 24 hours`)
                  }})</span
                >
              </template>
              <template v-else>
                <template v-if="value === false">
                  N/A
                </template>
                <tween-num
                  v-else
                  :value="parseInt(total_user)"
                  :initial="0"
                  :formatter="numberFormat"
                  key="not_promotion"
                ></tween-num>
                <span>&nbsp;{{ $t('users') }}</span>
              </template>
            </template>
            <template>
              <v-btn
                outline
                fab
                small
                color="primary"
                :loading="loadingEstimate"
                @click="loadCountData(groupType.value)"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
          </p>
          <template>
            <div v-if="['instagram'].includes(groupType.value) && sendtype == 'promotion'">
              {{
                $t('broadcasts_will_sent_subscribers_ig', {
                  total_user: total_user >= 0 ? total_user : 'N/A'
                })
              }}
            </div>
            <div
              v-if="
                (['facebook'].includes(groupType.value) && sendtype == 'promotion') ||
                  (['customize'].includes(groupType.value) &&
                    sendtype == 'promotion' &&
                    ['instagram', 'facebook'].includes(filter.app.value))
              "
            >
              {{
                $t(
                  'Broadcasts will be sent to subscribers who interacts in Messenger with the Business page within 24 hours. If you prefer to send messages to more target users (total no. {total_user}), you are required to use Sponsored Message.',
                  { total_user: total_user >= 0 ? total_user : 'N/A' }
                )
              }}
              <a
                href="https://blog.zwiz.app/handlefbpolicy2020/"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('Click') }}</a
              >
            </div>
          </template>
          <p v-if="!['line', 'line-group', 'instagram', 'google'].includes(groupType.value)">
            ***
            {{
              $t(
                '(Importing the previous users before installing the chatbot can be applied with premium package only.)'
              )
            }}
          </p>
        </template>
        <multiselect
          v-model="groupType"
          :options="groupTypeOptions"
          label="label"
          :allow-empty="false"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          track-by="label"
          @select="onSelectGroupType"
        ></multiselect>

        <multiselect
          class="mt-2"
          v-if="['line', 'line-group'].includes(groupType.value)"
          v-model="groupTypeLine"
          :options="groupTypeOptionsLine"
          label="label"
          :allow-empty="false"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          track-by="label"
          @select="onSelectGroupTypeLine"
        ></multiselect>

        <div class="mt-3" v-if="!['facebook', 'instagram', 'google'].includes(groupType.value)">
          {{ $t('Remark') }}:
          {{ $t('Price of broadcast LINE message will be depended on LINE Official Account') }}
          <div>
            {{ $t('Customize broadcast on LINE will deliver to users based on ZWIZ.AI chatbot.') }}
          </div>
        </div>

        <template
          v-if="['line'].includes(groupType.value) && ['line'].includes(groupTypeLine.value)"
        >
          <v-checkbox
            :label="$t('Broadcast to all LINE users without relying on ZWIZ.AI users')"
            v-model="isLineBroadcastAll"
            :false-value="false"
            :true-value="true"
            color="primary"
            persistent-hint
            :hint="$t('Remark') + ': ' + $t('Messages sent will not be counted')"
          ></v-checkbox>
        </template>

        <div style="position: relative" v-if="groupType.value == 'customize'">
          <div class="form-control">
            <v-premium-plan-popup
              :showAll="false"
              marginTop="65"
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
              text="Want to specific customer broadcasts?. Upgrade from premium onwards, starting at 500 baht/month, Upgrade now!."
            ></v-premium-plan-popup>
            <template>
              <div
                style="
                  border: 1px solid #eee;
                  padding: 5px 10px 0px 10px;
                  border-radius: 10px;
                  margin-top: 15px;
                  background: #fbfbfb;
                "
              >
                <filter-customer
                  :isBroadCast="true"
                  :total_user="total_user"
                  v-model="filter"
                  @onChangeStatus="onChangeStatus"
                  v-on:emitFilterApp="handleEvent"
                  @filterContext="filterContext"
                ></filter-customer>
              </div>
            </template>
          </div>
        </div>
      </v-container>

      <template
        v-if="
          ['', 'all', 'facebook', 'instagram'].includes(groupType.value) ||
            (groupType.value == 'customize' &&
              !['line', 'line-group', 'google'].includes(filter.app.value))
        "
      >
        <v-divider></v-divider>
        <v-container>
          <div>
            {{ $t('Message Type') }}
            <a href="https://blog.zwiz.app/5typesfbbroadcast/" target="blank"
              ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
            ></a>
            <span class="primary-color" v-if="sendtype === 'NTN_BROADCAST'"
              >( {{ $t('Remaining Broadcast quota') }}
              <tween-num
                :value="
                  tntType.value == 'DAILY'
                    ? parseInt(count_optin_daily_available)
                    : tntType.value == 'WEEKLY'
                    ? parseInt(count_optin_weekly_available)
                    : tntType.value == 'MONTHLY'
                    ? parseInt(count_optin_monthly_available)
                    : false
                "
                :initial="0"
                :formatter="numberFormat"
                key="promotion"
              ></tween-num>
              {{ $t('users') }} )</span
            >
          </div>
          <!-- <a href="https://blog.zwiz.app/5typesfbbroadcast/" target="_blank">{{
            $t(
              'To avoid being blocked by Facebook, click here to read more about how to use each Message Type'
            )
          }}</a> -->
          <div v-if="sendtype === 'NTN_BROADCAST'">
            <small class="primary-color">{{
              $t(
                '* Remark: Marketing Messages broadcast will limit 1 time per day / 1 user and refresh Marketing Messages broadcast quota every 24 hours.'
              )
            }}</small>
          </div>
          <v-radio-group v-model="sendtype" style="display: block;">
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                :md4="
                  ['', 'all', 'facebook'].includes(groupType.value) ||
                    (groupType.value == 'customize' &&
                      !['line', 'line-group', 'instagram'].includes(filter.app.value))
                "
                class="py-2"
              >
                <v-radio
                  :label="$t('Promotional Message (within 24 hours)')"
                  value="promotion"
                  color="primary"
                ></v-radio>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                class="py-2 d-flex"
                v-if="
                  ['', 'all', 'facebook'].includes(groupType.value) ||
                    (groupType.value == 'customize' &&
                      !['line', 'line-group', 'instagram'].includes(filter.app.value))
                "
              >
                <v-radio
                  value="ACCOUNT_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    {{ $t('Account Update') }}
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                          $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                class="py-2"
                v-if="
                  ['', 'all', 'facebook'].includes(groupType.value) ||
                    (groupType.value == 'customize' &&
                      !['line', 'line-group', 'instagram'].includes(filter.app.value))
                "
              >
                <v-radio
                  value="CONFIRMED_EVENT_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    {{ $t('Confirmed Event Update') }}
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                          $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex
                xs12
                sm6
                :md4="
                  ['', 'all', 'facebook'].includes(groupType.value) ||
                    (groupType.value == 'customize' &&
                      !['line', 'line-group', 'instagram'].includes(filter.app.value))
                "
                class="py-2"
              >
                <v-radio value="NTN_BROADCAST" color="primary">
                  <template v-slot:label>
                    <div>
                      <span
                        style="color:red"
                        v-if="
                          ['instagram'].includes(groupType.value) ||
                            (groupType.value == 'customize' &&
                              ['instagram'].includes(filter.app.value))
                        "
                      >
                        {{ $t('Beta') }}
                      </span>
                      <span style="color:red" v-else> {{ $t('New') }} </span>
                      {{ $t('Marketing Messages') }}
                      <v-modal-help>
                        <div slot="body">
                          <img class="responsive-img" src="/static/img/assets/help/NTN-01.jpg" />
                          <div style="padding: 15px">
                            <p class="strong">{{ $t('Marketing Messages') }}</p>

                            <span class="ml-4">
                              {{ $t('recurring_notification_popup') }}
                            </span>
                            <p class="mt-3">
                              {{ $t('recurring_notification_popup1') }}
                            </p>
                            <ol class="ml-4 mt-3" type="1" style="margin-bottom: 15px">
                              <li style="list-style: decimal">
                                {{ $t('recurring_notification_popup2') }}
                              </li>
                              <li style="list-style: decimal">
                                {{ $t('recurring_notification_popup3') }}
                              </li>
                              <li style="list-style: decimal">
                                {{ $t('recurring_notification_popup4') }}
                              </li>
                            </ol>
                          </div>
                        </div>
                      </v-modal-help>
                      <!-- <v-dialog v-model="dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <a href="javascript:void(0)" v-bind="attrs" v-on="on"
                            ><i
                              style="font-size: 16px; color: #ed1e79;"
                              class="fas fa-question-circle"
                            ></i
                          ></a>
                        </template>

                        <v-card>
                          <v-card-title class="pb-0">
                            <h3>บรอดแคสต์แบบ NTN</h3>
                            <v-spacer></v-spacer>
                            <v-btn flat fab icon small @click="dialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-card-title>

                          <v-card-text class="pt-1">
                            <span class="ml-4"
                              >คือการบรอดแคสต์ที่สามารถส่งข้อความหาลูกค้าที่ได้ทำการกดยอมรับข่าวสารจากทางเพจได้ทุกประเภทข้อความ</span
                            >
                            และไม่จำกัดว่าต้องเป็นข้อความภายใน 24 ชม.เท่านั้น เช่น
                            ส่งข้อความเชิงพาณิชย์ และโปรโมชั่นต่างๆ หาลูกค้าเก่า
                            ที่กดปุ่มยอมรับข่าวสารบนแชท Messenger สำเร็จแล้ว
                          </v-card-text>
                        </v-card>
                      </v-dialog> -->
                    </div>
                  </template>
                </v-radio>
                <template
                  v-if="
                    ['instagram'].includes(groupType.value) ||
                      (groupType.value == 'customize' && ['instagram'].includes(filter.app.value))
                  "
                >
                  <small class="primary--text">
                    {{ $t('remark_bata_ig_recurring') }}
                  </small>

                  <a
                    href="https://m.me/361231620965547?ref=IG - Recurring"
                    target="_blank"
                    class="small"
                  >
                    <small class="primary--text" style="text-decoration: underline;">
                      {{ $t('remark_bata_ig_recurring_click') }}
                    </small>
                  </a>
                </template>
                <!-- <multiselect
                  v-if="sendtype === 'NTN_BROADCAST'"
                  v-model="tntType"
                  :options="tntTypeOption"
                  label="label"
                  :allow-empty="false"
                  :searchable="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                  track-by="label"
                  @select="onSelectNtnType"
                ></multiselect> -->
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                class="py-2"
                v-if="
                  ['', 'all', 'facebook'].includes(groupType.value) ||
                    (groupType.value == 'customize' &&
                      !['line', 'line-group', 'instagram'].includes(filter.app.value))
                "
              >
                <v-radio
                  value="POST_PURCHASE_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    {{ $t('Post-Purchase Update') }}
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                          $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                v-if="
                  ['', 'all', 'facebook'].includes(groupType.value) ||
                    (groupType.value == 'customize' &&
                      !['line', 'line-group', 'instagram'].includes(filter.app.value))
                "
                class="py-2"
              >
                <v-radio
                  :label="$t('Promotional Message (Sponsored Message to all users)')"
                  value="sponsered"
                  color="primary"
                ></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>

          <v-dialog v-model="showSponser" max-width="640">
            <v-card>
              <div class="text-xs-right">
                <v-btn fab flat small @click="showSponser = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="text-xs-center">
                  <h4 v-html="$t('If you want to send Promotional Message to all users')"></h4>
                  <v-btn
                    class="mb-2"
                    href="https://blog.zwiz.app/handlefbpolicy2020/"
                    color="primary"
                    depressed
                    target="_blank"
                    >{{ $t('click here') }}</v-btn
                  >
                  <div class="mb-5 grey--text">
                    {{ $t('to learn “How to use Sponsored Message?”') }}
                  </div>
                  <div class="mb-4">
                    <span class="warning--text">{{ $t('Remark') }}</span>
                    {{ $t('This Message Type must be managed in Facebook Ads Manager') }}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- <a
            href="https://blog.zwiz.app/handlefbpolicy2020/"
            target="_blank"
          >{{$t('Promotional Message (Sponsored Message to all users)')}}</a>-->
        </v-container>
      </template>
      <template>
        <v-divider></v-divider>
        <div
          style="position: relative"
          :style="{
            'padding-bottom':
              $store.getters.getPackage !== 'premium' || isCoachlab ? '112px' : '0px'
          }"
        >
          <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage !== 'premium' || isCoachlab"
            text="You can specify the name of the broadcast you want to resend the broadcast to users who have not received it yet. Can be used from the premium package onwards, starting at 500 baht/month, upgrade now."
          ></v-premium-plan-popup>
          <v-container>
            <div>
              {{ $t('Rebroadcast') }}
            </div>
            <small style="font-size: 10px">
              {{
                $t(
                  'Specify broadcast name that want to resend message to user who haven’t received'
                )
              }}</small
            >
            <div>
              <multi-select-custom
                v-model="excludeIds"
                :options="broadcastItems"
                label="name"
                trackBy="id"
                :placeholder="$t('Select Broadcast')"
                :multiple="true"
                :clearOnSelect="false"
                :closeOnSelect="false"
                :disabled="$store.getters.getPackage !== 'premium' || isCoachlab"
                @scroll:end="onScrollEnd"
                @input="handleExcludeChange"
              >
              </multi-select-custom>
            </div>
          </v-container>
        </div>
      </template>
      <template
        v-if="
          groupType.value !== 'google' &&
            !(groupType.value === 'customize' && ['google'].includes(filter.app.value))
        "
      >
        <v-divider></v-divider>
        <v-container
          v-if="
            !(
              (groupType.value == 'line' || groupType.value == 'line-group') &&
              isLineBroadcastAll == true
            )
          "
        >
          <div>{{ $t('Notification Setting') }}</div>
          {{ groupType.value }}
          <v-radio-group v-model="pushtype" row>
            <v-radio
              :label="$t('silent push')"
              value="SILENT_PUSH"
              color="primary"
              v-tooltip.top="
                $t(
                  'Silent Push notification will display a phone notification without sound. Use it for regular messages that dont require immediate action.'
                )
              "
            ></v-radio>
            <v-radio
              :label="$t('regular push')"
              value="REGULAR"
              color="primary"
              v-tooltip.top="
                $t(
                  'Regular Push notification will make a sound and display a phone notification. Use it for important messages.'
                )
              "
            ></v-radio>
            <v-radio
              :label="$t('no push')"
              value="NO_PUSH"
              color="primary"
              v-tooltip.top="
                $t(
                  'No Push notification will not display a phone notification and make any sound. Use it for messages that dont require immediate action.'
                )
              "
            ></v-radio>
          </v-radio-group>
        </v-container>
      </template>
      <v-divider></v-divider>

      <v-container>
        <template v-if="type == 'json'">
          <div v-if="groupType.value">
            <intent-group
              :isIgType="
                ['instagram'].includes(groupType.value) ||
                  (groupType.value == 'customize' && ['instagram'].includes(filter.app.value))
              "
              :messagesType="sendtype"
              :isBroadCast="true"
              v-model="messages"
              :hasAlternative="false"
              :isWelcome="true"
              :availableBubbles="availableBubbles"
              :isHasPrefill="
                !(
                  (groupType.value == 'line' || groupType.value == 'line-group') &&
                  isLineBroadcastAll == true
                )
              "
              :groupType="groupType.value"
              :customType="customGroupType.value"
            ></intent-group>
          </div>
          <div
            v-if="
              !(
                (groupType.value == 'line' || groupType.value == 'line-group') &&
                isLineBroadcastAll == true
              )
            "
          >
            <div class="small" style="margin-top: 10px">{{ $t('Choice') }}</div>
            <div class="caption grey--text" v-if="selectedBot.instagram_business_account">
              * {{ $t('Not available if using with Button/List Menu') }}
            </div>
            <div class="caption grey--text" v-if="selectedBot.packages.includes('whatsapp')">
              * {{ $t('Quick messages cannot be used on the WhatsApp platform.') }}
            </div>
            <div class="mb-3"></div>

            <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <tags
                v-model="choice"
                :tags="choices"
                @tags-changed="addChoices"
                @before-adding-tag="checkQuickReply"
                style="margin-bottom: 5px"
                :btnText="$t('Add choice')"
              ></tags>

              <span class="text-error" v-if="errorTag.length > 0">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="type == 'template'">
          <div style="overflow-x: scroll; margin-bottom: 5px">
            <div
              style="margin: 0; overflow: auto"
              :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
            >
              <div
                style="float: left; width: 300px; margin-right: 15px"
                v-for="(generic, index) in generics"
                :key="'generic_' + index"
              >
                <generic-manage
                  :vkey="index"
                  v-model="generics[index]"
                  @onDelete="onDeleteGeneric(index)"
                  :isValidate="true"
                >
                  <move-horizontal
                    slot="move"
                    :index="index"
                    :max="generics.length"
                    @onMove="onMove(index, $event)"
                    style="display: inline-block; margin-top: 0"
                  ></move-horizontal>
                </generic-manage>
              </div>
              <div
                v-if="generics.length < 10"
                @click="addGeneric"
                style="
                  position: relative;
                  float: left;
                  width: 300px;
                  border: 4px dashed #eee;
                  border-radius: 20px;
                  height: 300px;
                  cursor: pointer;
                "
              >
                <div
                  style="
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -10px;
                    margin-top: -23px;
                    font-size: 32px;
                  "
                >
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </template>

        <div
          class="mt-4"
          v-if="
            !(
              (groupType.value == 'line' || groupType.value == 'line-group') &&
              isLineBroadcastAll == true
            )
          "
        >
          <div class="hr"></div>
          <div class="text-xs-center" style="margin: -13px">
            <a
              class="text btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
              style="position: relative"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
              ></i>
            </a>
          </div>

          <template>
            <div style="margin-top: 25px" v-show="showAdvanced">
              <div>
                {{ $t('Status') }}
                <v-premium-lock :inline="true"></v-premium-lock>
              </div>
              <div
                v-if="
                  selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                "
                class="mt-1 primary--text"
              >
                {{ update_status ? update_status : '-' }}
              </div>
              <template v-else>
                <div
                  class="form-control"
                  :class="{ 'has-error': errors.has('broadcastUpdateStatus') }"
                >
                  <!-- <input
                    type="text"
                    class="form-control"
                    name="broadcastUpdateStatus"
                    data-vv-name="broadcastUpdateStatus"
                    :data-vv-as="$t('Status')"
                    :placeholder="$t('Status')"
                    v-model="update_status"
                  /> -->
                  <v-layout wrap>
                    <v-flex sm11>
                      <multiselect
                        :options="statusOptions"
                        v-model="update_status"
                        :multiple="false"
                        :taggable="true"
                        @tag="onSelectStatus"
                        @input="errorMaxlength = false"
                      >
                      </multiselect>
                      <small style="color:red" v-if="errorMaxlength">
                        {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                      >
                    </v-flex>
                    <v-flex sm1>
                      <v-btn samll icon @click="update_status = null">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <span class="text-error" v-show="errors.has('broadcastUpdateStatus')">{{
                    errors.first('broadcastUpdateStatus')
                  }}</span>
                </div>
              </template>

              <div class="mt-3">
                {{ $t('Tag') }}
                <v-premium-lock :inline="true"></v-premium-lock>
              </div>

              <template
                v-if="
                  selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                "
              >
                <div class="primary--text" v-if="update_tags.length == 0">
                  {{ $t('No tag') }}
                </div>
                <template v-else>
                  <template v-for="(tag, tindex) in update_tags">
                    <v-chip
                      :key="`tags_${tindex}`"
                      class="white--text"
                      disabled
                      small
                      color="primary"
                    >
                      {{ tag }}
                    </v-chip>
                  </template>
                </template>
              </template>
              <template v-else>
                <!-- <div
                  class="form-control"
                  :class="{ 'has-error': errors.has('broadcastUpdateTags') }"
                >
                  <multiselect
                    :options="tagOptions"
                    v-model="update_tags"
                    :placeholder="$t('Tag')"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag"
                  >
                  </multiselect>
                  <span class="text-error" v-show="errors.has('broadcastUpdateTags')">{{
                    errors.first('broadcastUpdateTags')
                  }}</span>
                </div> -->
                <tags
                  v-if="tagOptions"
                  :combobox="true"
                  v-model="usertag"
                  :tags="usertags"
                  @tags-changed="addUserTags"
                  @before-adding-tag="checkUserTags"
                  :itemOption="tagOptions"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add tag')"
                ></tags>
                <span class="text-error" v-if="errorUsertag.length > 0">
                  <template v-if="errorUsertag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorUsertag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorUsertag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </template>
            </div>
          </template>
        </div>
      </v-container>

      <template>
        <v-divider class="mt-3"></v-divider>
        <div style="position: relative">
          <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            text="Choose the broadcast time according to preferences. Can be used from the Premium package onwards, starting at 500 baht/month, Upgrade now!."
          ></v-premium-plan-popup>
          <v-container
            :style="{
              'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '230px' : 'auto'
            }"
          >
            <v-layout>
              <v-flex>{{ $t('Schedule Broadcast') }}</v-flex>
              <v-flex class="text-xs-right">
                <toggle-button
                  class="mt-2"
                  :value="broadcast.isschedule"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="onBroadcastSchedule"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="broadcast.isschedule">
              <v-flex xs11 sm6 class="form-control">
                <v-layout wrap>
                  <v-flex xs6 sm8>
                    <v-menu
                      ref="showScheduleDate"
                      v-model="showScheduleDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input type="text" name id v-model="scheduleDate" v-on="on" readonly />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="scheduleDate"
                        @input="showScheduleDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <time-picker
                      v-model="scheduleTime"
                      :minute-interval="10"
                      full-width
                    ></time-picker>
                    <!-- <v-menu
                      ref="showScheduleTime"
                      v-model="showScheduleTime"
                      :close-on-content-click="false"
                      :return-value.sync="scheduleTime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input type="text" name id v-model="scheduleTime" readonly v-on="on" />
                      </template>
                      <v-time-picker
                        v-if="showScheduleTime"
                        v-model="scheduleTime"
                        full-width
                        @click:minute="$refs.showScheduleTime.save(scheduleTime)"
                        color="primary"
                        :allowed-minutes="allowedStep"
                      ></v-time-picker>
                    </v-menu> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>

      <v-container>
        <br />
        <div class="text-xs-center" style="margin-bottom: 10px">
          <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
            <i class="far fa-eye"></i>
            {{ $t('preview') }}
          </a>
          <preview-message
            v-if="showPreview"
            @close="showPreview = false"
            :messages="messages"
            :choice="choices"
            :questions="questions"
            :isComment="false"
            :comment="''"
          ></preview-message>
          <input
            type="hidden"
            v-validate="'min_value:1'"
            :name="'messages'"
            v-model="messages[0].length"
            :data-vv-as="$t('Broadcast Messages')"
          />
          <div class="form-control mt-4" :class="{ 'has-error': errors.has('messages') }">
            <span class="text-error" v-show="errors.has('messages')">{{
              errors.first('messages')
            }}</span>
          </div>
        </div>
        <div class="text-xs-center mt-2">
          <v-btn color="grey" outline @click="onBack">
            <i class="fas fa-chevron-left mr-1"></i>
            {{ $t('Back') }}
          </v-btn>
          <v-btn color="grey" outline @click="onSave" v-if="!isSaveOnly">
            <i class="fas fa-save mr-1"></i>
            {{ $t('save_draft') }}
          </v-btn>
          <v-btn depressed @click="onSend" color="primary">
            <i class="fas fa-paper-plane mr-1"></i>
            {{ $t(isSaveOnly ? 'save_and_send' : 'Send') }}
          </v-btn>
        </div>
      </v-container>
    </template>

    <modal-dialog2 v-if="showUpgrade" @close="showUpgrade = false">
      <div slot="body" style="overflow: auto">
        <div style="position: relative">
          <v-premium-plan-popup :inline="true" backgroundColor="white"></v-premium-plan-popup>
        </div>
      </div>

      <div slot="footer">
        <div class="text-xs-center">
          <button
            type="button"
            class="btn btn-flat"
            data-dismiss="modal"
            @click="showUpgrade = false"
          >
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </modal-dialog2>
  </div>
</template>
<script>
import api from '@/api'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import config from '@/config'
import datepicker from 'vuejs-datepicker'
import IntentGroup from '@/components/view/intent/IntentGroup'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import TweenNum from 'vue-tween-number'
import ModalDialog2 from '@/components/elements/ModalDialog2'
// import { constants } from 'http2';
import Tags from '@/components/elements/Tags'
import Multiselect from 'vue-multiselect'
import PreviewMessage from '@/components/elements/PreviewMessage'
import FilterCustomer from '@/components/elements/FilterCustomer'
import utc from 'dayjs/plugin/utc'
import TimePicker from '@/components/elements/TimePicker.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import MultiSelectCustom from '../../elements/MultiSelectCustom.vue'

export default {
  props: ['value', 'isSaveOnly'],

  data: function() {
    return {
      errorMaxlength: false,
      dialog: false,
      statusOptions: [],
      showSponser: false,
      showScheduleDate: false,
      showScheduleTime: false,
      scheduleDate: null,
      scheduleTime: null,
      showAdvanced: false,

      showPreview: false,
      questions: [],
      tagOptions: null,
      nodeTag: [],
      tag: '',
      usertag: '',
      singleStatus: '',
      showUpgrade: false,
      broadcast: undefined,
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      update_status: '',
      update_tags: [],
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      groupTypeOptions: [],
      groupTypeOptionsLine: [
        {
          label: this.$t('Friends'),
          value: 'line'
        },
        {
          label: this.$t('Group'),
          value: 'line-group'
        }
      ],
      tntTypeOption: [
        {
          label: this.$t('DAILY'),
          value: 'DAILY'
        },
        {
          label: this.$t('WEEKLY'),
          value: 'WEEKLY'
        },
        {
          label: this.$t('MONTHLY'),
          value: 'MONTHLY'
        }
      ],
      intents: [],
      type: 'json',
      tntType: {
        label: this.$t('DAILY'),
        value: 'DAILY'
      },
      groupType: {},
      groupTypeLine: {
        label: this.$t('Friends'),
        value: 'line'
      },
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      choice: '',
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        },
        {
          label: this.$t('Line'),
          value: 'line-group'
        },
        {
          label: this.$t('Instagram'),
          value: 'instagram'
        }
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],
          // default_action: {
          //   type: 'web_url',
          //   url: ''
          // },

          enable: true
        }
      ],
      filter: {
        specialcondition: '',
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        intent: null,
        email: '',
        phoneno: '',
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        tags_include: '',
        tags_exclude: '',
        status: '',
        statustype: 'includes',
        payStatus: null
      },
      errorTag: [],
      errorUsertag: [],
      errorFilterTag: [],
      errorFilterStatus: [],
      estimate_user: 0,
      count_optin_daily: 0,
      count_optin_daily_available: 0,
      count_optin_weekly: 0,
      count_optin_weekly_available: 0,
      count_optin_monthly: 0,
      count_optin_monthly_available: 0,
      total_user: '',
      loadingEstimate: true,
      counttype: 'onetime',
      loadCount: true,
      isLineBroadcastAll: false,
      customGroupType: { label: this.$t('Facebook'), value: 'facebook' },
      loadEstimatereachFirstTime: true,
      // Broadcast exclude user
      excludeIds: [],
      broadcastItems: [],
      broadcastConfig: {
        page: 1,
        total: 0,
        offset: 0,
        limit: 20,
        isLoading: false
      }
    }
  },
  components: {
    ToggleButton,
    datepicker,
    IntentGroup,
    GenericManage,
    MoveHorizontal,
    TweenNum,
    ModalDialog2,
    Tags,
    Multiselect,
    PreviewMessage,
    FilterCustomer,
    TimePicker,
    MultiSelectCustom
  },
  mounted: function() {
    var vm = this
    vm.getUserStatusList()
    vm.getUserTagList()
    dayjs.extend(utc)

    vm.reset()

    if (vm.name === '') {
      vm.name = 'Broadcast_' + dayjs().format('YYYY_MM_DD_HH_mm')
    }

    if (vm.broadcast.scheduletime) {
      var scheduleDate = dayjs(vm.broadcast.scheduletime)
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = {
        HH: scheduleDate.format('HH'),
        mm: scheduleDate.format('mm')
      }
    } else {
      var scheduleDate = dayjs()
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = {
        HH: scheduleDate.add(1, 'hours').format('HH'),
        mm: '00'
      }
    }
    // vm.$nextTick(function() {
    //   vm.loadData(vm.groupType.value)
    // })
    const packages = vm.selectedBot.packages
    if (packages.includes('facebook')) {
      vm.groupTypeOptions.push({
        label: vm.$t('Facebook'),
        value: 'facebook'
      })
    }
    if (packages.includes('line')) {
      vm.groupTypeOptions.push({
        label: vm.$t('Line'),
        value: 'line'
      })
    }
    if (packages.includes('instagram')) {
      vm.groupTypeOptions.push({
        label: vm.$t('Instagram'),
        value: 'instagram'
      })
    }
    if (packages.includes('google')) {
      vm.groupTypeOptions.push({
        label: vm.$t('Google'),
        value: 'google'
      })
    }
    vm.groupTypeOptions.push({
      label: vm.$t('Customize'),
      value: 'customize'
    })
    if (packages.includes('facebook')) {
      vm.groupType = {
        label: vm.$t('Facebook'),
        value: 'facebook'
      }
    } else {
      vm.groupType = {
        label: vm.$t('Line'),
        value: 'line'
      }
    }
    var filters = ''
    if (vm.broadcast.m_condition) {
      filters = vm.broadcast.m_condition.split('app=')[1].split('&')[0]
    }
    if (vm.broadcast.m_condition && vm.broadcast.m_condition.includes('&')) {
      vm.groupType = {
        label: vm.$t('Customize'),
        value: 'customize'
      }
    } else {
      let groupType = {
        label: vm.$t('Facebook'),
        value: 'facebook'
      }
      vm.channelOptions.forEach(item => {
        if (item.value === filters) {
          groupType = item
        }
      })

      vm.groupType = groupType
      if (filters === 'line-group') {
        vm.groupTypeLine = {
          label: this.$t('Group'),
          value: 'line-group'
        }
      } else if (filters === 'line') {
        vm.groupTypeLine = {
          label: this.$t('Friends'),
          value: 'line'
        }
      } else if (filters === 'line-broadcast') {
        vm.groupType = {
          label: this.$t('Line'),
          value: 'line'
        }
        vm.isLineBroadcastAll = true
      }
    }

    // if()

    vm.$nextTick(() => {
      vm.getBroadcast()
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      isCoachlab: 'isCoachlab',
      userTags: 'getUserTags',
      loadingUserTags: 'getLoadingUserTags'
    }),
    availableBubbles() {
      const vm = this
      if (
        (vm.groupType.value == 'line' || vm.groupType.value == 'line-group') &&
        vm.isLineBroadcastAll == true
      ) {
        return ['text', 'image', 'video', 'line_flex', 'line_imagemap', 'line_sticker']
      } else if (vm.groupType.value == 'google') {
        return ['text', 'button', 'image', 'generic']
      } else if (vm.sendtype === 'NTN_BROADCAST') {
        return [
          'text',
          'button',
          'image',
          'generic',
          'catalogue',
          'meta_pay',
          'video',
          'payment_form',
          'add_cart',
          'line_flex',
          'line_imagemap',
          'line_sticker'
        ]
      }
      return undefined
    },
    filterIntent: function() {
      var vm = this
      if (vm.intents && vm.intents.length > 0) {
        vm.intents.sort(function(a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
            return 1
          }
          if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
      }
      var intents = []
      if (vm.intents) {
        vm.intents.map(function(intent, index) {
          intents.push(intent.intentname)
        })
      }
      return intents
    },
    choices: {
      get() {
        let vm = this
        if (vm.quick_reply && vm.quick_reply !== '') {
          // console.log(vm.quick_reply)
          var quickReplies = []
          quickReplies = vm.quick_reply.split(',')
          var result = []
          if (quickReplies) {
            quickReplies.map(function(val, index) {
              result.push({ text: val })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(val, index) {
            result.push(val.text)
          })
        }
        vm.quick_reply = result.join(',')
      }
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function(s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    },
    usertags: {
      get() {
        let vm = this
        if (
          vm.broadcast &&
          vm.broadcast.update_user_tags !== '' &&
          typeof vm.broadcast.update_user_tags !== 'undefined'
        ) {
          var usertags = []
          usertags = vm.broadcast.update_user_tags.split(',')
          usertags = usertags.filter(el => {
            return el != ''
          })
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function(tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          this.nodeTag = result
          return result
        } else {
          return this.nodeTag
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function(tag) {
            return tag.text
          })
        }
        this.update_tags = result
      }
    }
  },
  methods: {
    handleEvent(data) {
      if (data.value === 'line') {
        data = {
          label: this.$t('Friends'),
          value: 'line'
        }
      }
      this.filter.app = data
      this.customGroupType = data
    },
    onSelectStatus(value) {
      if (value.length <= 25) {
        this.errorMaxlength = false
        this.update_status = value
      } else {
        this.errorMaxlength = true
      }
    },
    async getUserTagList() {
      const vm = this
      await vm.$store.dispatch('loadTags')
      if (vm.userTags.length > 0) {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name
        })
      } else {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name
        })
      }
    },
    async getUserStatusList() {
      const vm = this
      await vm.$store.dispatch('loadStatus')
      if (vm.userStatus.length > 0) {
        vm.statusOptions = vm.userStatus.map(item => {
          return item.name
        })
      }
    },
    onSelectNtnType(type) {},
    async loadCountData(group) {
      group = group || this.groupType.value
      this.loadingEstimate = true
      if (this.counttype == 'onetime') {
        try {
          var {
            count,
            total,
            count_optin_daily,
            count_optin_daily_available,
            count_optin_weekly,
            count_optin_weekly_available,
            count_optin_monthly,
            count_optin_monthly_available
          } = await this.estimateReach(group)
          this.total_user = total
          this.estimate_user = count
          this.count_optin_daily = count_optin_daily
          this.count_optin_daily_available = count_optin_daily_available
          this.count_optin_weekly = count_optin_weekly
          this.count_optin_weekly_available = count_optin_weekly_available
          this.count_optin_monthly = count_optin_monthly
          this.count_optin_monthly_available = count_optin_monthly_available
        } catch (error) {
          this.total_user = false
          this.estimate_user = false
          this.count_optin_daily = false
          this.count_optin_daily_available = false
          this.count_optin_weekly = false
          this.count_optin_weekly_available = false
          this.count_optin_monthly = false
          this.count_optin_monthly_available = false
          if (
            this.$store.getters.getPackage == 'premium' ||
            this.selectedBot.pagetype == 'enterprise'
          )
            this.counttype = 'recursive'
        }
      } else {
        try {
          var {
            count,
            total,
            count_optin_daily,
            count_optin_daily_available,
            count_optin_weekly,
            count_optin_weekly_available,
            count_optin_monthly,
            count_optin_monthly_available
          } = await this.recursiveLoadUser(group, { limit: 5000, offset: 0 })
          this.estimate_user = count
          this.total_user = total
          this.count_optin_daily = count_optin_daily
          this.count_optin_daily_available = count_optin_daily_available
          this.count_optin_weekly = count_optin_weekly
          this.count_optin_weekly_available = count_optin_weekly_available
          this.count_optin_monthly = count_optin_monthly
          this.count_optin_monthly_available = count_optin_monthly_available
        } catch (error) {
          this.total_user = false
          this.estimate_user = false
          this.count_optin_daily = false
          this.count_optin_daily_available = false
          this.count_optin_weekly = false
          this.count_optin_weekly_available = false
          this.count_optin_monthly = false
          this.count_optin_monthly_available = false
        }
      }
      this.loadEstimatereachFirstTime = false
      this.customGroupType = this.filter['app']
      this.loadingEstimate = false
    },
    async recursiveLoadUser(group, { limit, offset }) {
      var { total, isnext, count } = await this.estimateReach(group, {
        limit: limit,
        offset: offset
      })
      if (isnext) {
        var next = await this.recursiveLoadUser(group, {
          limit: limit,
          offset: offset + limit
        })
        return {
          total: parseInt(total) + (next.total ? parseInt(next.total) : 0),
          isnext: isnext,
          count: parseInt(count) + (next.count ? parseInt(next.count) : 0)
        }
      } else {
        return {
          total: total ? parseInt(total) : 0,
          isnext: false,
          count: count ? parseInt(count) : 0
        }
      }
    },
    addTag(newTag) {
      if (newTag.length > 25) {
        this.$swal.fire({
          title: this.$t('Message cannot be longer than 20 alphabets'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
        return false
      }
      const tag = newTag
      console.log(newTag)
      this.tagOptions.push(tag)
      this.update_tags.push(tag)
    },
    allowedStep: m => m % 10 === 0,
    onChangeStatus() {
      this.loadData(this.groupType.value)
    },
    filterContext() {
      this.loadData(this.groupType.value)
    },
    loadData(group = '') {
      if (group === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.loadCountData(group)
        } else {
          this.loadCountData('')
        }
      } else {
        this.loadCountData(group)
      }
    },
    onBroadcastSchedule() {
      // this.broadcast.isschedule = !this.broadcast.isschedule
      this.$set(this.broadcast, 'isschedule', !this.broadcast.isschedule)
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function(newTags) {
      this.status = newTags
    },
    addChoices: function(newTags) {
      this.choices = newTags
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.choices.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.choices.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorUsertag = []
      if (obj.tag.text.length > 20) {
        this.errorUsertag.push('overmaxlength')
        obj.error()
      } else if (this.choices.length >= 10) {
        this.errorUsertag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.choices.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorUsertag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    },
    getIntent: function(callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          response.data.map(function(val, index) {
            var intent = val
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    onActiveStartDate: function(value) {
      if (dayjs(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function(value) {
      if (dayjs(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function(value) {
      if (dayjs(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function(value) {
      if (dayjs(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    onOptionChange: function(option) {
      this.type = option
      // this.saveWelcomeMessage()
    },
    onDeleteGeneric: function(index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Generic Message cannot be less than 1')
      }
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function() {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        })
      }
    },
    onBack: function() {
      var vm = this
      vm.$emit('onClose')
    },
    onSave: function() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()

          return false
        }
        // if (vm.groupType == 'customize' && vm.$store.getters.getPackage != 'premium') {
        //     vm.showUpgrade = true
        //     return false
        // }
        vm.$store.dispatch('loading')
        vm.updateBroadcast(false, function(status) {
          if (status) {
            vm.$swal.fire({
              title: vm.$t('Success! Broadcast {name} save', {
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          } else {
            vm.$swal.fire({
              title: vm.$t('Oop! Broadcast {name} save draft fail', {
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          }

          $('html, body').animate({ scrollTop: 0 })

          vm.$store.dispatch('loading')
        })
      })
    },
    onSend: function() {
      var vm = this

      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.groupType.value === 'customize' && vm.$store.getters.getPackage == 'normal') {
          vm.showUpgrade = true
          return false
        }
        vm.$swal
          .fire({
            title: vm.$t('Do you want to broadcast {name}?', {
              name: vm.name.replace(/\<|\>/g, '')
            }),
            html: `<small><span class="warning--text">${vm.$t('Warning!')}</span>${vm.$t(
              'If you send too many broadcasts,your inbox might not be able to access temporarily.'
            )}<small>
            <div class="subheading mt-2" style="line-height: 27px !important;">
            <span class="warning--text">${vm.$t('Warning!')}</span>
            ${vm.$t(
              'You messages must follow the Message Type’s regulation. To avoid being blocked by Facebook, please recheck them before sending the broadcast.'
            )}</div>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then(result => {
            if (result.value) {
              vm.$store.dispatch('loading')
              vm.updateBroadcast(true, function(status) {
                if (status) {
                  vm.$swal
                    .fire({
                      title: vm.$t('Broadcast {sent_name} sent', {
                        sent_name: vm.name.replace(/\<|\>/g, '')
                      }),
                      type: 'success',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true
                    })
                    .then(function() {
                      vm.$emit('onClose', vm.name)
                    })
                } else {
                  vm.$swal.fire({
                    title: vm.$t('Oop! Broadcast {name} save draft fail', {
                      name: vm.name.replace(/\<|\>/g, '')
                    }),
                    type: 'error',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                }
                vm.$store.dispatch('loading')
              })
            }
          })
      })
    },
    updateBroadcast: function(isSend, callback) {
      var vm = this

      var scheduletime = dayjs(vm.scheduleDate + ' ' + this.formatTime(vm.scheduleTime))
      var scheduletimeUTC = dayjs.utc(scheduletime || '00:00')
      var data = {
        pageid: vm.selectedBot.pageid,
        name: vm.name,
        m_val: vm.message,
        m_type: 'json',
        m_quick_reply: vm.quick_reply,
        m_condition: '',
        sendflag: isSend,
        page_access_token: vm.selectedBot.page_access_token,
        pushtype: vm.pushtype,
        sendtype: vm.sendtype,
        update_status: vm.update_status,
        update_tags: vm.update_tags.join(',')
      }

      if (vm.sendtype === 'NTN_BROADCAST') {
        if (vm.tntType.value === 'DAILY') {
          data.sendtype = 'opt_in_daily'
        } else if (tntType.value === 'WEEKLY') {
          data.sendtype = 'opt_in_weekly'
        } else if (tntType.value === 'MONTHLY') {
          data.sendtype = 'opt_in_monthly'
        } else {
          data.sendtype = false
        }
      }
      if (vm.$store.getters.getPackage == 'premium' && !vm.isCoachlab) {
        data.isschedule = vm.broadcast.isschedule
        data.scheduletime = scheduletimeUTC.format('YYYY-MM-DDTHH:mm:ss.sssZ')
      } else {
        data.isschedule = false
        data.scheduletime = null
      }
      if (vm.groupType.value === 'facebook') {
        data.m_condition = 'app=facebook'
      } else if (vm.groupType.value === 'line') {
        if (vm.isLineBroadcastAll) data.m_condition = 'app=line-broadcast'
        else if (vm.groupTypeLine.value === 'line-group') data.m_condition = 'app=line-group'
        else data.m_condition = 'app=line'
      } else if (vm.groupType.value === 'instagram') {
        data.m_condition = 'app=instagram'
      } else if (vm.groupType.value === 'google') {
        data.m_condition = 'app=google'
      } else if (vm.groupType.value === 'customize') {
        data.filter = vm.filter
      }

      if (vm.broadcast && vm.broadcast.id) {
        data.broadcastid = vm.broadcast.id
      }

      if (vm.excludeIds.length && vm.groupType.value === 'customize') {
        Object.assign(data.filter, { exclude_broadcast_ids: vm.excludeIds })
      } else if (vm.excludeIds.length) {
        data.m_condition += `&exclude_broadcast_ids=[${vm.excludeIds.join(',')}]`
      }

      var messages = vm.checkEmptyMessage(vm.messages)

      if (isSend == true && (messages.length == 0 || messages[0].length == 0)) {
        callback(false)
        return false
      }

      data.m_val = JSON.stringify(messages)

      vm.$emit('onSave', {
        data: data,
        onSave: function(status, broadcastid) {
          if (status) {
            if (broadcastid) {
              data.id = broadcastid
            }
            vm.broadcast = data
            vm.cached_broadcast = Object.assign({}, vm.broadcast)
          }
          callback(status)
        }
      })
    },
    estimateReach: function(type, filter) {
      var vm = this
      var data, params, filters

      data = {
        pageid: vm.selectedBot.pageid,
        payment_flag: vm.filter.payStatus ? vm.filter.payStatus.value : null,
        tags_include: vm.filter.tags_include ? vm.filter.tags_include : '',
        tags_exclude: vm.filter.tags_exclude ? vm.filter.tags_exclude : '',
        facebook_page_id: vm.selectedBot.facebook_page_id || '',
        exclude_broadcast_ids: vm.excludeIds
      }
      if (filter) {
        params = {
          ...filter
        }
      }
      if (type === 'customize') {
        filters = JSON.stringify(vm.filter)
        data.filter = JSON.parse(filters)
        data.filter.status = data.filter.status.toString()
      } else {
        if (type === 'facebook') {
          Object.assign(data, { app: 'facebook' })
        } else if (type === 'line') {
          Object.assign(data, { app: 'line' })
        } else if (type === 'line-group') {
          Object.assign(data, { app: 'line-group' })
        } else if (type === 'instagram') {
          Object.assign(data, { app: 'instagram' })
        } else if (type === 'google') {
          Object.assign(data, { app: 'google' })
        }
      }
      return new Promise((resolve, reject) => {
        api.estimateReach({ data, params }, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            resolve({ isnext: response.is_next || false, ...response.data })
          } else {
            reject('No data')
          }
        })
      }, this)
    },
    onSelectGroupTypeLine: function(type) {
      if (type.value == 'line-group') {
        this.isLineBroadcastAll = false
      }
      this.filter.app = type
      this.loadData(type.value)
      this.sendtype = 'promotion'
    },
    onSelectGroupType: function(type) {
      if (type.value == 'line') {
        if (this.groupTypeLine.value === 'line-group') {
          type = {
            label: this.$t('Line Group'),
            value: 'line-group'
          }
        }
      }

      this.loadData(type.value)
      this.sendtype = 'promotion'
    },
    reset: async function() {
      var vm = this
      // vm.getIntent(function() {})
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)

        this.update_status = vm.broadcast.update_user_status
        try {
          // this.update_tags = vm.broadcast.update_user_tags.split(',')
          // this.update_tags = this.update_tags.filter(el => {
          //   return el != ''
          // })
          // this.tagOptions = this.update_tags
        } catch (error) {}
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter(el => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters
            .map(function(filter) {
              var value = filter.split(/=(.+)/)
              if (value.length > 1) {
                switch (value[0]) {
                  case 'fullname':
                  case 'gender':
                  case 'app':
                  case 'email':
                  case 'status':
                  case 'tags':
                  case 'tags_include':
                  case 'tags_exclude':
                  case 'phoneno':
                    vm.filter[value[0]] = value[1]
                    return { id: value[0], value: value[1] }
                  case 'messagesent':
                    var messagesent = value[1].split('__')
                    vm.filter[value[0]] = {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__'
                    }
                    return {
                      id: value[0],
                      value: {
                        value: messagesent[1],
                        symbol: messagesent[0] + '__'
                      }
                    }
                  case 'locale':
                    var locales = value[1].split(',')
                    vm.filter.locale = []
                    vm.filter.locale = vm.localeOptions
                      .map((configLocal, clindex) => {
                        if (locales.includes(configLocal.value)) {
                          return configLocal
                        } else {
                          return null
                        }
                      })
                      .filter(el => {
                        return el != null
                      })
                    return { id: 'locale', value: vm.filter.locale }
                  case 'intent':
                    vm.filter.intent = value[1].split(',')
                    return { id: 'intent', value: value[1].split(',') }
                  case 'timestamp_from':
                    vm.filter.activeDate.start = dayjs(value[1]).toDate()
                    return { id: 'activeDate_start', value: dayjs(value[1]).toDate() }
                  case 'timestamp_to':
                    vm.filter.activeDate.end = dayjs(value[1]).toDate()
                    return { id: 'activeDate_end', value: dayjs(value[1]).toDate() }
                    break
                  case 'registertimestamp_from':
                    vm.filter.registerDate.start = dayjs(value[1]).toDate()
                    return { id: 'registerDate_start', value: dayjs(value[1]).toDate() }
                  case 'registertimestamp_to':
                    vm.filter.registerDate.end = dayjs(value[1]).toDate()
                    return { id: 'registerDate_end', value: dayjs(value[1]).toDate() }
                  case 'exclude_broadcast_ids':
                    vm.excludeIds =
                      value && value[1] ? value[1].replace(/[\[\]]/g, '').split(',') : []

                  default:
                    break
                }
              }
            })
            .filter(el => el)
          if (
            f.length == 1 &&
            (vm.filter['app'] == 'facebook' ||
              vm.filter['app'] == 'line' ||
              vm.filter['app'] == 'line-group' ||
              vm.filter['app'] == 'line-broadcast' ||
              vm.filter['app'] == 'instagram' ||
              vm.filter['app'] == 'google')
          ) {
            let option = vm.groupTypeOptions.find(el => {
              if (['line'].includes(vm.filter['app']) && el.value == 'line') {
                return true
              } else if (['line-group'].includes(vm.filter['app']) && el.value == 'line-group') {
                return true
              } else return el.value == vm.filter['app']
            })
            if (option) {
              if (vm.filter['app'] == 'line-broadcast') vm.isLineBroadcastAll = true
              vm.groupType = option
            } else {
              vm.groupType = vm.groupTypeOptions[0]
            }
            // vm.groupType =
            //   vm.filter['app'] == 'facebook' ? vm.groupTypeOptions[1] : vm.groupTypeOptions[2]
          } else {
            let customize_option = vm.groupTypeOptions.find(el => el.value == 'customize')
            vm.filter.activeDate.start =
              vm.filter.activeDate && vm.filter.activeDate.start ? vm.filter.activeDate.start : null
            vm.filter.activeDate.end =
              vm.filter.activeDate && vm.filter.activeDate.end ? vm.filter.activeDate.end : null
            vm.groupType = customize_option
          }
        } else {
          vm.groupType = vm.groupTypeOptions[0]
        }
        vm.name = vm.broadcast.name
        // vm.type = vm.broadcast.m_type;
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype ? vm.broadcast.sendtype : 'promotion'
        vm.sendtype =
          vm.broadcast &&
          ['opt_in_daily', 'opt_in_weekly', 'opt_in_monthly'].includes(vm.broadcast.sendtype)
            ? 'NTN_BROADCAST'
            : vm.sendtype
        vm.pushtype = vm.broadcast.pushtype ? vm.broadcast.pushtype : 'SILENT_PUSH'

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          try {
            vm.messages = JSON.parse(vm.broadcast.m_val)
          } catch (error) {}
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function(index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function(index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
        if (vm.excludeIds.length) {
          const payload = {
            pageid: this.selectedBot.pageid,
            broadcast_ids: vm.excludeIds.join(','),
            status: 'broadcasted'
          }
          const setData = items => {
            const mapItems = items.map(item => ({name: item.name, id: item.id}))
            this.broadcastItems = [
              ...new Set([...this.broadcastItems, ...mapItems].map(JSON.stringify))
            ].map(JSON.parse)
            // this.broadcastConfig.total = Number(total)
            this.broadcastConfig.isLoading = false
          }
          api.getBroadcast(payload, function(error, response) {
            if (error) {
              console.error(error)
              return
            }
            if (response.data) {
              setData(response.data || [])
            }
          })
        }
        // vm.getDefaultExcludes()
      } else {
        vm.broadcast = {
          m_condition: null,
          name: null,
          m_type: 'json',
          m_quick_reply: null,
          m_val: null
        }
        vm.isSave = false
        vm.isFail = false
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.messages = [[]]
        vm.choice = ''
        vm.errorTag = []
        vm.errorUsertag = []
        vm.estimate_user = 0
      }
      vm.$nextTick(function() {
        vm.loadData(vm.groupType.value)
      })

      if (vm.name == '') {
        vm.name = 'Broadcast_' + dayjs().format('YYYY_MM_DD_HH_mm')
      }
    },
    onScrollEnd(reached) {
      if (
        reached &&
        !this.broadcastConfig.isLoading &&
        this.broadcastConfig.total > this.broadcastConfig.offset
      ) {
        this.broadcastConfig.offset += this.broadcastConfig.limit
        this.getBroadcast()
      }
    },
    async getBroadcast() {
      if (this.broadcastConfig.isLoading) return
      this.broadcastConfig.isLoading = true
      try {
        const payload = {
          pageid: this.selectedBot.pageid,
          limit: this.broadcastConfig.limit,
          offset: this.broadcastConfig.offset,
          status: 'broadcasted'
        }
        const setData = (items, total) => {
          const mapItems = items.map(item => ({name: item.name, id: item.id}))
          this.broadcastItems = [
            ...new Set([...this.broadcastItems, ...mapItems].map(JSON.stringify))
          ].map(JSON.parse)

          this.broadcastConfig.total = Number(total)
          this.broadcastConfig.isLoading = false
        }
        await api.getBroadcast(payload, function(error, response) {
          if (error) {
            console.error(error)
            return
          }

          if (response.data) {
            setData(response.data || [], response.total || 0)
          }
        })
      } catch (error) {
        this.broadcastConfig.isLoading = false
      }
    },
    handleExcludeChange() {
      this.loadData(this.groupType.value)
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this
      vm.reset()
    },
    filter: {
      handler: async function() {
        if (
          !this.loadEstimatereachFirstTime &&
          this.groupType.value == 'customize' &&
          this.$store.getters.getPackage == 'premium' &&
          !this.isCoachlab
        ) {
          await this.loadCountData(this.groupType.value)
        }
      },
      deep: true
    },
    groupType: function() {},
    showSponser: function(newVal, oldVal) {
      if (newVal == false && oldVal == true) {
        this.sendtype = 'promotion'
      }
    },
    sendtype: function(newVal) {
      if (newVal == 'sponsered') {
        this.showSponser = true
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastManage.vue